export const VideoStreamService = {
  assignStream: (element: HTMLVideoElement | null, stream: MediaStream | null) => {
    if (!element) return;
    if (element.srcObject === stream) return;

    // Fast path for removal
    if (!stream) {
      element.pause();
      element.srcObject = null;
      return;
    }

    // Assign new stream
    element.srcObject = stream;

    // Handle playback with retry and error suppression
    const playWithRetry = (attempt = 0) => {
      if (attempt >= 3 || element.srcObject !== stream) return;

      const playPromise = element.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          if (error.name === 'AbortError') {
            // Expected when rapid switching occurs, ignore
            return;
          }
          console.warn(`Play attempt ${attempt + 1} failed:`, error);
          setTimeout(() => playWithRetry(attempt + 1), 500 * (attempt + 1));
        });
      }
    };

    playWithRetry();
  },

  stopStream: (stream: MediaStream | null) => {
    if (!stream) return;

    try {
      stream.getTracks().forEach((track) => {
        try {
          track.stop();
          stream.removeTrack(track);
        } catch (e) {
          console.warn('Error stopping track:', e);
        }
      });
    } catch (e) {
      console.error('Error stopping stream:', e);
    }
  },
};
